import {
	batteryReductionOneTurn,
	carbonStolenThisTurn,
	churchOfPseudoscience,
	factoryReduction,
	factoryReductionOneTurn,
	handSize1,
	handSizeMinus3,
	mulligan,
	noHandNextSeason,
	recharge1,
	recyclingPlant,
	regulatoryCapture,
	summitCarbonDump,
	takeNeighboringEnergy1,
} from '@lc/const/modifiers';
import { GameState } from '@lc/interface/gameState/types';

const monthModifierList = [
	carbonStolenThisTurn,
	churchOfPseudoscience,
	mulligan,
	recyclingPlant,
	factoryReductionOneTurn,
	batteryReductionOneTurn,
]; // todo
const seasonalModifierList = [
	factoryReduction, // todo
	handSizeMinus3,
	handSize1, // todo
	noHandNextSeason, // todo
	recharge1, // todo
	regulatoryCapture, // todo
	summitCarbonDump, // todo (complete contract, add modifier as punishment function, clear next season after summit)
	takeNeighboringEnergy1, // todo
];

// HERE do the action of updating modifiers. Depending on modifier, update given each below timeline advancement
// i.e. recyclingPlant updates when advanceMonth
//
async function updateModifiers(gameState: GameState, modifierList: string[]) {
	for (let i = 0; i < gameState.playerStateArray.length; i++) {
		const pState = gameState.playerStateArray[i];
		for (let z = pState.modifiers.length; z >= 0; z--) {
			if (modifierList.includes(pState.modifiers[z])) {
				pState.modifiers.splice(z, 1);
			}
		}
	}
}

// some contracts are "global", meaning they're never necessary to reset. it's a one time check
async function resetSeasonalPlayerContractVars(gameState: GameState) {
	for (let i = 0; i < gameState.playerStateArray.length; i++) {
		const pState = gameState.playerStateArray[i];
		pState.factoriesBuiltThisSeason = 0;
		pState.factoriesBuiltThisSeasonFromCarbonOnly = 0;
		pState.batteriesBuiltThisSeason = 0;
	}
}

function updateWeightIndex(gameState: GameState) {
	gameState.weightIndex =
		gameState.seasonTracker * 3 + gameState.monthTracker;
}

export async function updateModifiersMonth(gameState: GameState) {
	await updateModifiers(gameState, monthModifierList);
}

export async function updateModifiersSeason(gameState: GameState) {
	await updateModifiers(gameState, seasonalModifierList);
	await resetSeasonalPlayerContractVars(gameState);
}

export function getNextActivePlayer(gameState: GameState) {
	if (gameState.turnOrder.length > 0) {
		gameState.activePlayerId = gameState.turnOrder[0];
		gameState.turnOrder.shift();
	} else {
		console.log('NO ACTIVE PLAYERS REMAIN');
	}
}
export function incrementMonth(gameState: GameState) {
	gameState.monthTracker++;
	updateWeightIndex(gameState);
	updateModifiersMonth(gameState);
}
export async function incrementSeason(gameState: GameState) {
	gameState.seasonTracker++;
	gameState.seasonalNewsCards = []; // new season, reset those news cards!
}
export function resetTurnTracker(gameState: GameState) {
	if (
		gameState.currentTurnTypePlayerTableOrder == null ||
		gameState.currentTurnTypePlayerTableOrder.length < gameState.numPlayers
	) {
		gameState.turnOrder = [...gameState.initPlayerTableOrder];
	} else {
		gameState.turnOrder = [...gameState.currentTurnTypePlayerTableOrder];
	}
}
export async function resetMonthTracker(gameState: GameState) {
	gameState.monthTracker = 0;
	updateWeightIndex(gameState);
	updateModifiersMonth(gameState);
}
